import Vue from "vue";

/**
 * 显示定义弹框
 */
export const showTimerDialog = (options) => {
    return Vue.prototype.$windowTimerDialog && Vue.prototype.$windowTimerDialog.showWindowTimerAlert(options);
};
